import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { CONTACT } from "../lib/content";

export default function Donate() {
  const { settings } = useSettings();
  const url = settings?.donation_url;

  return (
    <>
      <PageHero
        eyebrow="Donate"
        lines={[
          { text: "Help keep Hawaiʻi local." },
          { text: "Every contribution helps.", className: "font-serifg italic font-semibold" },
        ]}
        lead="Your gift supports Kamalama Foundation's mission and every program we run — immediate community response, Feed the Community meal days, the Kamalama Holiday Fair, and the Priced Out of Kauaʻi by Lowell recovery program."
      />

      <section className="wrap py-16 sm:py-20">
        <div className="grid gap-10 lg:grid-cols-2">
          <Reveal className="flex flex-col items-start gap-6">
            {url ? (
              <a
                className="btn btn-terra !px-10 !py-4 !text-lg"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="donate-outbound-main-button"
              >
                Donate now
              </a>
            ) : (
              <>
                <button
                  type="button"
                  aria-disabled="true"
                  className="btn btn-terra btn-dim !px-10 !py-4 !text-lg"
                  data-testid="donate-disabled-main-button"
                >
                  Donate now
                </button>
                <p className="text-sm text-muted-foreground" data-testid="donate-waiting-note">
                  Online giving opens soon. To give now, contact us at{" "}
                  {CONTACT.email} or {CONTACT.phone}.
                </p>
              </>
            )}
            <h2 className="font-display text-2xl font-bold">Where your gift goes</h2>
            <div className="flex flex-col gap-3">
              <p>
                <b>Now:</b>{" "}
                <span className="text-muted-foreground">
                  immediate community response — verified resource sharing,
                  volunteer coordination, in-kind support, and Feed the
                  Community meal days.
                </span>
              </p>
              <p>
                <b>Next:</b>{" "}
                <span className="text-muted-foreground">
                  the planned Hurricane Lowell rent-first recovery response to
                  help verified eligible business owners stabilize one month of
                  business rent and one month of household rent or mortgage.
                </span>
              </p>
              <p>
                <b>Always:</b>{" "}
                <span className="text-muted-foreground">
                  community events like the Holiday Fair that raise funds and
                  bring ʻohana together.
                </span>
              </p>
              <p>
                <b>If funds remain:</b>{" "}
                <span className="text-muted-foreground">
                  supplemental help with verified essential business and
                  household needs, as approved by the Board.
                </span>
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.12} className="flex flex-col gap-4">
            <div className="callout">
              <b className="font-display">Donor disclosure</b>
              <p className="text-muted-foreground">
                Donations will support Kamalama Foundation's tax-exempt
                charitable mission and programs — including immediate community
                response, Feed the Community, the Kamalama Holiday Fair, and
                the Priced Out of Kauaʻi by Lowell recovery program — subject
                to available funds, Board-approved criteria, and applicable
                processing, fundraising, and program-administration expenses.
              </p>
            </div>
            <div className="callout">
              <b className="font-display">Tax deductibility</b>
              <p className="text-muted-foreground">
                Kamalama Foundation is a tax-exempt charitable organization
                recognized under Section 501(c)(3) of the Internal Revenue
                Code. Contributions are tax-deductible to the extent permitted
                by law. Donations are made to the Foundation and cannot be
                designated to a specific individual or business.
              </p>
            </div>
            <div className="callout">
              <b className="font-display">Sunday transparency</b>
              <p className="text-muted-foreground">
                Every Sunday we post funds raised, costs, and funds available
                for the program.
              </p>
              <Link
                to="/transparency"
                className="link-underline w-fit font-semibold text-primary dark:text-accent"
                data-testid="donate-transparency-link"
              >
                See the latest update
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
